import { de } from './de'
import { en } from './en'

export const locale = { de, en }
